import { AxiosPost } from "../AxiosWrapper";
import { DOCUMENTSTORE_SERVICE_URL } from "../../constants/ServiceUrls";

export const getDocumentExportKeys = (exportKeyType) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/GetDocumentExportKeys`,
    { exportKeyType }
  );
};

export const downloadFileFromClientBucket = (documentIdentifier, cb) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/DownloadFileStream`,
    {
      documentIdentifier: documentIdentifier,
    },
    { responseType: "blob" }
  ).then((response) => {
    if (response instanceof Blob) {
      return window.URL.createObjectURL(response);
    } else return;
  });
};

export const downloadFilePreviewFromClientBucket = (documentIdentifier, cb) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/DownloadFilePreviewStream`,
    {
      documentIdentifier: documentIdentifier,
    },
    { responseType: "blob" }
  ).then((response) => {
    const { type } = response;
    const Stream = window.URL.createObjectURL(response);

    return { type, Stream };
  });
};

export const downloadDocumentsWithReasons = ({
  documentIds: documentIdentifiers = [],
  reasonIds = [],
  asFileType = false,
  IncludePublicComments = false,
  IncludePrivateComments = false,
}) =>
  AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}
api/File/DownloadDocuments`,
    { documentIdentifiers, reasonIds, asFileType, IncludePrivateComments, IncludePublicComments},
    { responseType: "blob" }
  );

export const downloadDocuments = (
  documentIdentifiers,
  ProtectionPassword,
  reasonIds
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}
api/File/DownloadDocuments`,
    { documentIdentifiers, ProtectionPassword, reasonIds },
    { responseType: "blob" }
  );
};

export const downloadMetadataInASpecifiedFormat = (
  exportKeys,
  documentIdentifiers,
  documentFormat,
  exportKeyType,
  ProtectionPassword
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}
api/File/DownloadMetadataInASpecifiedFormat`,
    {
      documentIdentifiers,
      documentFormat,
      exportKeys,
      exportKeyType,
      ProtectionPassword,
    },
    { responseType: "blob" }
  );
};

export const convertDocumentsToPDFsAndDownload = (
  documentIdentifiers,
  protectionPassword,
  reasonsIds
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}
api/File/ConvertDocumentsToPDFsAndDownload`,
    {
      documentIdentifiers,
      protectionSettings: {
        userPassword: protectionPassword,
      },
      reasonsIds,
    },
    { responseType: "blob" }
  );
};
export const mergeDocumentsAsPDFAndDownload = (
  documentIdentifiers,
  protectionPassword,
  reasonIds
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}
api/File/MergeDocumentsAsPDFAndDownload`,
    {
      documentIdentifiers,
      protectionSettings: {
        userPassword: protectionPassword,
      },
      reasonIds,
    },
    { responseType: "blob" }
  );
};
export const emailDocument = (
  DocumentIdentifier,
  DestinationEmailAddress,
  Message,
  reasonIds,
  IncludePublicComments = false,
  IncludePrivateComments = false
  ) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/EmailDocument`,

    {
      DocumentIdentifier,
      DestinationEmailAddress,
      Message,
      reasonIds,
      IncludePrivateComments,
      IncludePublicComments
    }
  );
};
export const recordDownloadOperationForAudit = (
  documentIdentifier,
  reasonIds
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/RecordDownloadOperationForAudit`,
    {
      documentIdentifier,
      reasonIds,
    }
  );
};
export const getDocumentPermissions = (folderId, documentTypeId) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/GetDocumentPermissions`,
    {
      folderId,
      documentTypeId,
    }
  );
};
export const uploadPrintReasons = (documentIdentifiers, reasonIds) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/RecordPrintDocumentOperation`,
    { documentIdentifiers, reasonIds }
  );
};

export const getPhysicalFiles = (getFilesParameters) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/GetPhysicalFiles`,
    getFilesParameters,
    { responseType: "blob" }
  ).then((response) => {
    if (response) return window.URL.createObjectURL(response);
    else return null;
  });
};

export const getPhysicalFileByLink = (getFilesParameters) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/GetPhysicalFileByLink`,
    getFilesParameters,
    { responseType: "blob" }
  ).then((response) => {
    if (response) return window.URL.createObjectURL(response);
    else return null;
  });
};

export const getPhysicalFileToken = (getFilesParameters) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/GetPhysicalFileToken`,
    getFilesParameters
  );
};

export const downloadPhysicalFilePreviewStream = (itemId, cb) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/DownloadPhysicalFilePreviewStream`,
    {
      itemId,
    },
    { responseType: "blob" }
  ).then((response) => {
    const { type } = response;
    const Stream = window.URL.createObjectURL(response);

    return { type, Stream };
  });
};

export const downloadResultsForPhysicalSearch = (downloadResultsParameters) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/File/DownloadResultsForPhysicalSearch`,
    downloadResultsParameters,
    { responseType: "blob" }
  );
};

export default {
  downloadFileFromClientBucket,
  downloadFilePreviewFromClientBucket,
  downloadDocuments,
  downloadDocumentsWithReasons,
  downloadMetadataInASpecifiedFormat,
  convertDocumentsToPDFsAndDownload,
  mergeDocumentsAsPDFAndDownload,
  emailDocument,
  recordDownloadOperationForAudit,
  getDocumentPermissions,
  uploadPrintReasons,
  getDocumentExportKeys,
  getPhysicalFiles,
  getPhysicalFileByLink,
  getPhysicalFileToken,
  downloadPhysicalFilePreviewStream,
  downloadResultsForPhysicalSearch,
};
